/*@ngInject*/
const ScoringRulesEditorModel = function ($rootScope, configurationMediator, configurationConstant) {

    let scoringRulesEditorModel = {};

    this.reset = function (scoringRuleId) {
        if (!_.isNil(scoringRuleId)) {
            scoringRulesEditorModel[scoringRuleId] = {
                scoringRule: null,
                isValid: false,
                hasUnsavedChanges: false
            };
        } else {
            scoringRulesEditorModel = {};
        }
    };

    this.buildScoringRule = function (scoringRuleId) {
        this.reset(scoringRuleId);

        if (_.isEmpty(scoringRuleId) || parseInt(scoringRuleId) === -1) {
            this.updateScoringRule({
                id: -1,
                name: null
            });
        } else {
            configurationMediator.getScoringRuleById(scoringRuleId).then(function (scoringRule) {
                this.updateScoringRule(scoringRule);
            }.bind(this));
        }
    };

    this.getScoringRule = function (scoringRuleId) {
        let model = scoringRulesEditorModel[scoringRuleId];
        return _.isNil(model) ? null : model.scoringRule;
    };

    this.setValid = function (scoringRuleId, valid) {
        const model = scoringRulesEditorModel[scoringRuleId];
        model.isValid = valid;
        $rootScope.$broadcast(configurationConstant.event.SCORING_RULE_UPDATED, scoringRuleId);
    };

    this.isValid = function (scoringRuleId) {
        const model = scoringRulesEditorModel[scoringRuleId];
        return _.isNil(model) || _.isNil(model.isValid) || model.isValid;
    };

    this.setUnsavedChanges = function (scoringRuleId, hasUnsavedChanges) {
        const model = scoringRulesEditorModel[scoringRuleId];
        if (!_.isNil(model)) {
            model.hasUnsavedChanges = hasUnsavedChanges;
        }
        $rootScope.$broadcast(configurationConstant.event.SCORING_RULE_UPDATED, scoringRuleId);
    };

    this.hasUnsavedChanges = function (scoringRuleId) {
        const model = scoringRulesEditorModel[scoringRuleId];
        if (model) {
            return model.hasUnsavedChanges;
        } else {
            return false;
        }
    };

    this.updateScoringRule = function (scoringRule) {
        scoringRulesEditorModel[scoringRule.id] = {
            scoringRule: _.cloneDeep(scoringRule),
            isValid: false,
            hasUnsavedChanges: false
        };
        $rootScope.$broadcast(configurationConstant.event.SCORING_RULE_UPDATED, scoringRule.id);
    };
};

angular.module('ums.configuration')
    .service('scoringRulesEditorModel', ScoringRulesEditorModel);
